import React from 'react';
import { getHeroStyle } from '../config/siteTheme';

function PageHero({ title, subtitle, variant = 'page', className = '', overlayOpacity, position }) {
  const style = getHeroStyle(overlayOpacity, position);
  const sectionClass = variant === 'home' ? 'hero' : 'page-hero';
  const subtitleClass = variant === 'home' ? 'hero-subtitle' : 'page-hero-subtitle';

  return (
    <section className={`${sectionClass} ${className}`.trim()} style={style}>
      <div className="hero-content">
        <h1>{title}</h1>
        {subtitle ? <p className={subtitleClass}>{subtitle}</p> : null}
      </div>
    </section>
  );
}

export default PageHero;
